<template>
  <div class="customer-wrp">
    <div class="title">客户信息</div>
    <div class="first-wrp">
      <FormList
        :list="formList"
        :data="merchantArchivesVo"
        :onChange="onInputChange"
        :onBlur="onBlur"
        :onFocus="onFocus"
      />
      <div class="rollup" v-if="companyListShow">
        <div
          @click="onSelectCompany(item)"
          class="rollup-item"
          v-for="(item, index) in companyList"
          :key="index"
        >
          <div class="rollup-company">
            <div>{{ item.name }}</div>
            <div v-if="item && item.managementBuyerFlag === 1">已添加</div>
          </div>
        </div>
      </div>
    </div>
    <div class="title address-title">客户收件地址</div>
    <FormList
      :list="addressList"
      :data="addresseeInfo"
      :onChange="onAddressInputChange"
      :onFocus="onFocus"
    />
    <ButtonRow
      firstText='返 回'
      :firstClick="cancel"
      secondText='保 存'
      :secondClick="confirm"
      :loading="loading"
      :bottom="true"
    />
  </div>
</template>

<script>
import {
  isTaxNo,
  isEmail,
  debounce,
  subMixStr,
  removeSpace
} from '@utils/basicUtil'
import { customerRequest } from '@services'
import {
  Row,
  Button,
  Notify
} from 'vant'
import FormList from '@components/FormList'
import ButtonRow from '@components/ButtonRow'

export default {
  data () {
    return {
      loading: false,
      addresseeInfo: {
        userName: '',
        address: '',
        telephone: '',
        email: '',
        defaultFlag: false // 0 默认
      },
      merchantArchivesVo: {
        company: '',
        taxNo: '',
        address: '',
        bankName: ''
      },
      companyList: [],
      companyListShow: false,
      formList: [
        {
          type: 'text',
          field: 'company',
          label: '客户名称',
          placeholder: '请输入客户名称',
          maxlength: 50,
          required: true
        },
        {
          type: 'text',
          field: 'taxNo',
          placeholder: '请输入客户税号',
          label: '客户税号',
          required: true
        },
        {
          type: 'text',
          field: 'address',
          placeholder: '请输入地址、电话',
          label: '地址、电话',
          required: true
        },
        {
          type: 'text',
          field: 'bankName',
          placeholder: '请输入银行、账号',
          label: '银行、账号',
          required: true
        }
      ],
      addressList: [
        {
          type: 'text',
          field: 'userName',
          label: '收件人',
          placeholder: '输入客户联系人姓名'
        },
        {
          type: 'text',
          field: 'address',
          label: '收件地址',
          placeholder: '输入客户收件地址'
        },
        {
          type: 'text',
          field: 'telephone',
          label: '电话',
          placeholder: '输入客户联系电话'
        },
        {
          type: 'text',
          field: 'email',
          placeholder: '请输入电票收件邮箱',
          label: '邮箱'
        },
        {
          type: 'switch',
          field: 'defaultFlag',
          label: '设为默认'
        }
      ]
    }
  },
  mounted () {
  },
  computed: {
  },
  methods: {
    debounce: debounce((vm) => { vm.getSmartTitles() }, 300),
    onSearchTitle (value) {
      if (value.length >= 1) {
        this.debounce(this)
      }
    },
    onBlur ({ e, field }) {
      if (field === 'company') {
        this.testBuyerName(e)
      }
    },
    testBuyerName () {
      if (!this.merchantArchivesVo.company.length) {
        return Notify({ type: 'danger', message: '请填写发票抬头' })
      } else {
        this.merchantArchivesVo.company = subMixStr(this.merchantArchivesVo.company, 100)
      }
    },
    onFocus ({ e, field }) {
      if (field === 'company') {
        this.companyListShow = true
      } else {
        this.companyListShow = false
      }
    },
    onInputChange ({ e, field }) {
      if (field === 'company') {
        this.companyListShow = true
        this.onSearchTitle(e)
      }
      this.merchantArchivesVo[field] = removeSpace(e)
    },
    onAddressInputChange ({ e, field }) {
      this.addresseeInfo[field] = e
    },
    async getSmartTitles () {
      const data = await customerRequest.smart.smartTitle({ companyName: this.merchantArchivesVo.company })
      if (data.success) {
        this.companyList = data.result
      } else {
        Notify({ type: 'danger', message: '获取抬头信息失败' })
      }
    },
    onSelectCompany (item) {
      this.companyListShow = false
      this.merchantArchivesVo = {
        company: item.name,
        taxNo: item.taxNo,
        address: item.address + item.tel,
        bankName: item.bankName + item.bankNo
      }
    },
    cancel () {
      this.$router.go(-1)
    },
    async confirm () {
      if (!isTaxNo(this.merchantArchivesVo.taxNo)) {
        return Notify({ type: 'danger', message: '税号仅支持9/15/18/19/20位大写字母、数字' })
      }
      if (!isEmail(this.addresseeInfo.email)) {
        return Notify({ type: 'danger', message: '邮箱格式不正确' })
      }
      if (this.merchantArchivesVo.company.trim().length === 0) {
        return Notify({ type: 'danger', message: '客户名称不能为空' })
      }
      if (this.merchantArchivesVo.address.trim().length === 0) {
        return Notify({ type: 'danger', message: '地址信息不能为空' })
      }
      if (this.merchantArchivesVo.bankName.trim().length === 0) {
        return Notify({ type: 'danger', message: '银行信息不能为空' })
      }
      this.loading = true
      const data = await customerRequest.address.addOrEdit({
        addresseeInfoRequestList: [{ ...this.addresseeInfo, defaultFlag: this.addresseeInfo.defaultFlag ? 0 : 1 }],
        merchantArchivesVo: this.merchantArchivesVo
      })
      if (data.success) {
        Notify({ type: 'success', message: '新增成功' })
        this.cancel()
      } else {
        Notify({ type: 'danger', message: data.message })
      }
    }

  },
  components: {
    FormList,
    ButtonRow,
    [Row.name]: Row,
    [Button.name]: Button
  }
}
</script>

<style lang="less" scoped src="./style.less"/>
